import ApplicationRecord from '@/models/application_record'

import {
  Model,
  Attr
} from 'spraypaint'

@Model()
export default class TransactionCategory extends ApplicationRecord {
  static jsonapiType = 'transaction_categories'

  @Attr name!: string
  @Attr reassignmentId!: string | undefined
}
